import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareHeaders } from '../../configuration/tokenHandling/prepareHeaders';
import type { Endpoints } from './generated/partner-network-api';

type FetchAccountProfilesParameters = Endpoints.get__profiles['parameters'];
type FetchAccountProfilesResponse = Endpoints.get__profiles['responses'][200];
type CreateAccountIdFlowPartnerConnectionParameters =
    Endpoints.put__partners_PartnerId_partnerAccounts_PartnerAccountId['parameters'];
type CreateAccountIdFlowPartnerConnectionResponse =
    Endpoints.put__partners_PartnerId_partnerAccounts_PartnerAccountId['responses'][204];

export const partnerNetworkApi = createApi({
    reducerPath: 'partnerNetworkApi',
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_PARTNER_NETWORK_SERVICE_BASE_URL,
        prepareHeaders,
    }),
    endpoints: builder => ({
        fetchAccountProfiles: builder.query<FetchAccountProfilesResponse, FetchAccountProfilesParameters>({
            query: ({ query }: FetchAccountProfilesParameters) => ({
                url: '/profiles',
                params: query,
            }),
        }),
        createAccountIdFlowPartnerConnection: builder.mutation<
            CreateAccountIdFlowPartnerConnectionResponse,
            CreateAccountIdFlowPartnerConnectionParameters
        >({
            query: ({ path, body }: CreateAccountIdFlowPartnerConnectionParameters) => ({
                url: `/partners/${path['partner-id']}/partner-accounts/${path['partner-account-id']}`,
                method: 'PUT',
                body,
            }),
        }),
    }),
    refetchOnFocus: true,
});

export const {
    useCreateAccountIdFlowPartnerConnectionMutation,
    useFetchAccountProfilesQuery,
    useLazyFetchAccountProfilesQuery,
} = partnerNetworkApi;
